<div class="card m-1">
  <div class="card-body">
    <div class="row">
      <div class="col-6 text-center">
        <h4>{{ delivery?.nid }}</h4>
        <p style="word-wrap: normal">
          Date d'ajout : {{ delivery?.createdAt | date: "dd/MM/yyyy hh:mm" }}
        </p>
        <p>{{ delivery?.business?.nomCommercial }}</p>
      </div>
      <div class="col-6 text-center">
        <div class="d-flex flex-nowrap" *ngIf="delivery?.driver">
          <i class="fa fa-user fa-2x mx-auto my-auto"></i>
          <div class="d-flex flex-column flex-nowrap">
            <h4>{{ delivery?.driver?.name }}</h4>
            <p class="text-info">{{ delivery?.driver?.tel }}</p>
          </div>
        </div>
        <div *ngIf="delivery?.dropOffAddress" class="d-flex flex-nowrap">
          <i class="fa fa-map-marker fa-2x mx-auto my-auto"></i>
          <div class="">
            <p
              style="word-wrap: normal"
              [ngClass]="
                delivery?.dropOff?.exactDropOffAddress ? '' : 'text-danger'
              "
            >
              {{ delivery?.dropOffAddress }}
            </p>
            <p class="text-center" style="word-wrap: normal">
              {{ delivery?.city }}, {{ delivery?.subDivision }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div
      style="background-color: #aba8a8; height: 1px; width: 100%"
      class="mt-3"
    ></div>
    <div class="mt-2 d-flex">
      <div class="my-auto">
        <app-jobs-badge-status [status]="delivery.status" [item]="delivery">
        </app-jobs-badge-status>
      </div>
      <div class="ml-auto">
        <i
          class="mx-1 fa fa-warning text-warning fa-2x"
          *ngIf="delivery?.isBlocking"
        ></i>
        <i
          class="mx-1 fa fa-warning text-danger fa-2x"
          *ngIf="delivery?.isUrgent"
        ></i>
        <i
          class="mx-1 fa fa-refresh text-info fa-2x"
          *ngIf="delivery?.isExchange"
        ></i>
        <i
          class="mx-1 fa fa-truck text-info fa-2x"
          *ngIf="
            delivery?.pickUpJob?.FinishJobDate &&
            delivery?.pickUpJob?.status === 6
          "
        ></i>
      </div>
    </div>
  </div>
</div>
